import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Redirect, Switch, Link } from "react-router-dom";
import environment from "environment";
import Analytics from "./Components/Elements/Analytics/Analytics";

import "./css/global.less";
import "./css/nav.less";
import "./css/tracks.less";
import "./css/comments.less";
import "./css/pages.less";

import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
// import DreamChimneyTopNav from "@dreamchimney/nav";

import HomePage from "./Pages/Home/HomePage";
import ApplyPage from "./Pages/Apply/ApplyPage";
import RegisterPage from "./Pages/Register/RegisterPage";
import ContactPage from "./Pages/Contact/ContactPage";
import ArchivePage from "./Pages/Archive/ArchivePage";
import HomeRewindPage from "./Pages/Home/HomeRewindPage";
import PromoTracksPage from "./Pages/PromoTracks/PromoTracksPage";
import SearchPage from "./Pages/Search/SearchPage";
import TrackPage from "./Pages/Track/TrackPage";
import GenrePage from "./Pages/Genre/GenrePage";
import GenreListPage from "./Pages/Genre/GenreListPage";
import DiscoverPage from "./Pages/Discover/DiscoverPage";
import PopularLastWeekPage from "./Pages/Popular/PopularLastWeekPage";
import ShufflePage from "./Pages/Shuffle/ShufflePage";
import ArtistPage from "./Pages/Artist/ArtistPage";
import ChimneyListPage from "./Pages/ChimneyList/ChimneyListPage";
import UserProfilePage from "./Pages/User/UserProfilePage";
import UserPasswordResetPage from "./Pages/User/UserPasswordResetPage";
import UserProfileEditPage from "./Pages/User/UserProfileEditPage";
import ChimneyProfilePage from "./Pages/Profile/ChimneyProfilePage";
import ChimneyProfileTracksPage from "./Pages/Profile/ChimneyProfileTracksPage";
import ChimneyProfileArchiveTracksPage from "./Pages/Profile/ChimneyProfileArchiveTracksPage";
import MessageBoardPage from "./Pages/MessageBoard/MessageBoardPage";
import MessageBoardNewPage from "./Pages/MessageBoard/MessageBoardNewPage";
import MessageBoardSearchPage from "./Pages/MessageBoard/MessageBoardSearchPage";
import MessageBoardTopicPage from "./Pages/MessageBoard/MessageBoardTopicPage";
import MessageBoardTodayPage from "./Pages/MessageBoard/MessageBoardTodayPage";
import MessageBoardTopicEditPage from "./Pages/MessageBoard/MessageBoardTopicEditPage";
import SiteMapPage from "./Pages/About/SiteMapPage";
import PlaylistAdd from "./Pages/Playlists/PlaylistAdd";
import PlaylistEdit from "./Pages/Playlists/PlaylistEdit";
import PlaylistPage from "./Pages/Playlists/PlaylistPage";
import PlaylistRecentPage from "./Pages/Playlists/PlaylistRecentPage";
import StatsPage from "./Pages/Stats/StatsPage";
import AboutPage from "./Pages/About/AboutPage";

import SettingsProvider from "~/Context/SettingsProvider";
// import MediaProvider from "./Components/library/MediaProvider";
import { useUser } from "~/Context/userContext";
import DevBanner from "./utils/DevBanner";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBackward,
  faCalendar,
  faCompactDisc,
  faCog,
  faComments,
  faComment,
  faCompass,
  faCubes,
  faEnvelope,
  faGem,
  faHeart,
  faHeadphonesAlt,
  faFlag,
  faForward,
  faMagic,
  faPlay,
  faEdit,
  faRandom,
  faRetweet,
  faSearch,
  faSignal,
  faSync,
  faThumbsUp,
  faTrophy,
  faUserSecret,
} from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartEmpty, faLightbulb } from "@fortawesome/free-regular-svg-icons";
import MainNav from "./Components/Elements/Global/MainNav";
import PageFooter from "./Components/Elements/Global/PageFooter";
import SiteFooter from "./Components/Elements/Global/SiteFooter";
import ScrollToTop from "./Components/Elements/Global/ScrollToTop";
import Jukebox from "./Components/Elements/Jukebox";
import { StateProvider } from "./Context/JukeboxContext";

const MenuPage = lazy(() => import("./Pages/Menu/MenuPage"));
const Step2 = lazy(() => import("./Pages/Menu/Step2"));
const NewsPage = lazy(() => import("./Pages/Menu/NewsPage"));
const ProfileEditPage = lazy(() => import("./Pages/Profile/ProfileEditPage"));
const TrackEditPage = lazy(() => import("./Pages/Track/TrackEditPage"));
const ChimneyProfileFavoritesPage = lazy(() => import("./Pages/Profile/ChimneyProfileFavoritesPage"));
const ChimneyPlaylistPage = lazy(() => import("./Pages/Profile/ChimneyPlaylistPage"));

const NoMatchPage = () => {
  return (
    <h3>
      Bummer. Page Not Found - <Link to="/">Back to Home</Link>
    </h3>
  );
  // return <Redirect to="/" />;
};

library.add(
  faBackward,
  faCompactDisc,
  faCalendar,
  faCog,
  faComment,
  faComments,
  faCompass,
  faCubes,
  faFlag,
  faForward,
  faGem,
  faHeart,
  faLightbulb,
  faEnvelope,
  faHeadphonesAlt,
  faHeartEmpty,
  faMagic,
  faPlay,
  faEdit,
  faRandom,
  faRetweet,
  faSearch,
  faSignal,
  faSync,
  faThumbsUp,
  faTrophy,
  faUserSecret
);

const App = () => {
  const { state: userState } = useUser();

  return (
    <div className="app-totd">
      <StateProvider>
        <DevBanner />
        <Suspense fallback={<div>Loading...</div>}>
          <Router basename="/tracks">
            {/* <DreamChimneyTopNav sitePrefix="tracks" userState={userState} withLinkProps={{ routerLink: Link }} /> */}
            <Link to="/">
              <div className="title-graphic" />
            </Link>
            <SettingsProvider>
              <Container className="app-container" fluid={false}>
                <Row className="middle-container">
                  <Col className="innerContent" xs={12}>
                    <div className="contentPadding">
                      <Analytics basename="/tracks" local={process.env.CLIENT_ENV !== "production"}>
                        <ScrollToTop />
                        <MainNav />
                        <Switch>
                          <Route exact path="/archive" component={ArchivePage} />
                          <Route exact path="/message-board" component={MessageBoardPage} />
                          <Route exact path="/message-board/new" component={MessageBoardNewPage} />
                          <Route exact path="/message-board/search" component={MessageBoardSearchPage} />
                          <Route exact path="/message-board/today" component={MessageBoardTodayPage} />
                          <Route exact path="/message-board/page/:page" component={MessageBoardPage} />
                          <Route exact path="/message-board/topic/:id" component={MessageBoardTopicPage} />
                          <Route exact path="/message-board/topic/:id/edit" component={MessageBoardTopicEditPage} />
                          <Route exact path="/playlist/add/:trackId" component={PlaylistAdd} />
                          <Route exact path="/playlists/recent" component={PlaylistRecentPage} />
                          <Route exact path="/playlist/:playlistId" component={PlaylistPage} />
                          <Route exact path="/playlist/:playlistId/edit" component={PlaylistEdit} />
                          <Route path="/promo-tracks" component={PromoTracksPage} />
                          <Route path="/search" component={SearchPage} />
                          <Route path="/chimneys" component={ChimneyListPage} />
                          <Route path="/artist/:artistSlug" component={ArtistPage} />
                          <Route path="/genre/:genreId(\d+)" component={GenrePage} />
                          <Route path="/genres" component={GenreListPage} />
                          <Route path="/discover" component={DiscoverPage} />
                          <Route exact path="/popular/last-week" component={PopularLastWeekPage} />
                          <Route exact path="/shuffle" component={ShufflePage} />
                          <Route path="/profile/:chimDir/tracks/year/:year/:page?" component={ChimneyProfileArchiveTracksPage} />
                          <Route path="/profile/:chimDir/tracks/:page" component={ChimneyProfileTracksPage} />
                          <Route path="/profile/:chimDir/contact" component={ContactPage} />
                          <Route path="/sitemap" component={SiteMapPage} />
                          <Route path="/stats" component={StatsPage} />
                          <Route path="/about" component={AboutPage} />
                          <Route path="/apply" component={ApplyPage} />
                          <Route path="/join" component={RegisterPage} />
                          {/* <Route path="/chat" component={() => <div>
                            <iframe src="https://chimneytracksagent-48498.chipp.ai" height="800px" width="100%" frameborder="0" title="Chimney Tracks Agent"></iframe>
                          </div>} /> */}

                          <PrivateRoute exact path="/menu/step-2/rerule/:trackId(\d+)">
                            <Step2 atStep={2} />
                          </PrivateRoute>
                          <PrivateRoute exact path="/menu/step-2">
                            <Step2 atStep={2} />
                          </PrivateRoute>

                          <PrivateRoute exact path="/menu">
                            <MenuPage atStep={1} />
                          </PrivateRoute>
                          <PrivateRoute exact path="/menu/news">
                            <NewsPage />
                          </PrivateRoute>

                          <PrivateRoute path="/profile/:chimDir/playlists">
                            <ChimneyPlaylistPage />
                          </PrivateRoute>
                          <PrivateRoute path="/profile/:chimDir/playlists">
                            <ChimneyProfileFavoritesPage />
                          </PrivateRoute>
                          <PrivateRoute path="/profile/:chimDir/favorites/:filter?">
                            <ChimneyProfileFavoritesPage />
                          </PrivateRoute>
                          <PrivateRoute exact path="/profile/edit/details">
                            <ProfileEditPage />
                          </PrivateRoute>

                          <Route exact path="/reset" component={UserPasswordResetPage} />
                          {/* this might be old and not used anymore */}
                          <Route exact path="/user/:userDir/edit" component={UserProfileEditPage} />
                          <Route exact path="/user/:userDir" component={UserProfilePage} />
                          <Route exact path="/profile/:chimDir" component={ChimneyProfilePage} />
                          <PrivateRoute exact path="/:trackId(\d+)/edit">
                            <TrackEditPage />
                          </PrivateRoute>
                          {/* this was making the catch all not work... */}
                          {/* <MediaProvider> */}
                          <Route exact path="/:trackId(\d+)" component={TrackPage} />
                          <Route exact path="/rewind/:days(\d+)" component={HomeRewindPage} />
                          <Route exact path="/" name="home" component={HomePage} />
                          {/* </MediaProvider> */}

                          <Route exact path="/" name="home" component={HomePage} />

                          <Route path="*">
                            <NoMatchPage />
                          </Route>
                        </Switch>
                      </Analytics>
                      <PageFooter />
                      <Jukebox />

                      {/* <Route render={() => <Redirect to="/" />} /> */}
                    </div>
                  </Col>
                </Row>
              </Container>
            </SettingsProvider>
          </Router>
        </Suspense>
        <SiteFooter />
      </StateProvider>
    </div>
  );
};

function PrivateRoute({ children, ...rest }) {
  const { state: userState } = useUser();
  // have to cloneElement to pass match to children element, the page component
  return (
    <Route
      {...rest}
      render={({ location, match }) => {
        const newChild = React.cloneElement(children, {
          match,
        });
        if (!userState.loaded) {
          return null;
        }
        return userState && userState.loggedin && userState.isChim ? (
          newChild
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
}

export default App;
